import './Pricing.scss'
import content from './content.json'
import Bg from './components/Bg'
import DiscountTag from './components/DiscountTag'
import PriceCard from './components/PriceCard'

export const Pricing = () => {
    const discount = 0.2
    const price = 8

    return (
        <section id={"pricing"} className={'pricing-section'}>
            <Bg />
            <div className={'pricing-inner-wrapper'}>
                <DiscountTag content={content}/>
                <h2 className={'pricing-header'}>{content?.title}</h2>
                <p className={'pricing-text'}>{content?.description}</p>
                <PriceCard price={price} discount={discount}/>
            </div>
        </section>
    )
}